import React from "react";
import cn from "classnames";
import styles from "./ButtonMain.module.scss";

interface ButtonMainProps {
    isLink?: boolean;
    isActive?: boolean;
    type?: "button" | "submit" | "reset";
    href?: string;
    disabled?: boolean;
    classButton?: string;
    className?: string;
    children: React.ReactNode;
    onClick?: (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
    target?: string
}

const ButtonMain: React.FC<ButtonMainProps> = (
    {
        isLink = false,
        isActive = false,
        type = "button",
        href,
        disabled = false,
        classButton,
        className,
        children,
        onClick,
        target
    }) => {

    const buttonClass = cn(
        styles.simpleButton,
        classButton,
        className,
        {
            [styles.isActive]: isActive,
            [styles.disabled]: disabled,
            [styles.imgClearButton]: classButton === "imgClearButton",
            [styles.imgRedButton]: classButton === "imgRedButton",
            [styles.imgBlackButton]: classButton === "imgBlackButton",
            [styles.imgWhiteButton]: classButton === "imgWhiteButton",
        }
    );

    // Вынесем логику рендера иконки в отдельную переменную
    const renderIcon = classButton && [
        "imgClearButton",
        "imgRedButton",
        "imgBlackButton",
        "imgWhiteButton",
    ].includes(classButton) && (
        <div className="me-2 d-flex">
            <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect width="40" height="40" rx="20" fill="#C53523"/>
                <path
                    d="M27.75 23.77C27.75 24.18 27.41 24.52 27 24.52C26.59 24.52 26.25 24.18 26.25 23.77V15.31L13.5301 28.0299C13.3801 28.1799 13.1901 28.2499 13.0001 28.2499C12.8101 28.2499 12.6201 28.1799 12.4701 28.0299C12.1801 27.7399 12.1801 27.2599 12.4701 26.9699L25.19 14.25H16.73C16.32 14.25 15.98 13.91 15.98 13.5C15.98 13.09 16.32 12.75 16.73 12.75H27C27.1097 12.75 27.2143 12.7743 27.3088 12.8178C27.3893 12.8537 27.4646 12.9044 27.5301 12.9699C27.5956 13.0354 27.6463 13.1107 27.6822 13.1912C27.7257 13.2857 27.75 13.3903 27.75 13.5V23.77Z"
                    fill="white"
                />
            </svg>
        </div>
    );

    // Выбираем, какой компонент рендерить
    const renderButton = (
        <button
            type={type}
            className={buttonClass}
            disabled={disabled}
            onClick={onClick}
        >
            {renderIcon}
            {children}
        </button>
    );

    const renderLink = (
        <a href={href} className={buttonClass} onClick={onClick} target={target}>
            {renderIcon}
            {children}
        </a>
    );

    return isLink ? renderLink : renderButton;
};

export default ButtonMain;
